var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12539 -18671)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-12539 18671)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12533.771 18674.422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2313.732-848.631q-4.4,0-8.793,0a3.673,3.673,0,0,1-3.97-3.95q0-5.184,0-10.368a3.691,3.691,0,0,1,3.874-3.857c.39,0,.78-.017,1.168,0,.356.019.472-.119.467-.472-.018-1.084-.008-2.168-.006-3.252a7.189,7.189,0,0,1,4.832-6.836,7.287,7.287,0,0,1,9.423,4.85,9.681,9.681,0,0,1,.233,2.209c.038,1,.021,2,0,3-.006.37.117.5.5.507a11.679,11.679,0,0,1,2.219.142,3.507,3.507,0,0,1,2.814,3.456q.036,5.489,0,10.977a3.614,3.614,0,0,1-3.715,3.587C2319.762-848.619,2316.747-848.631,2313.732-848.631Zm-.035-2.628h8.893c.975,0,1.243-.261,1.243-1.226q0-5.208,0-10.417c0-.924-.3-1.233-1.207-1.233q-8.892,0-17.785,0c-.9,0-1.229.325-1.229,1.222q0,5.234,0,10.468c0,.879.311,1.186,1.194,1.186Q2309.25-851.257,2313.7-851.259Zm.033-15.548c1.389,0,2.778-.008,4.167.006.349,0,.474-.108.466-.467-.02-1.05.011-2.1-.011-3.151a4.494,4.494,0,0,0-3.885-4.617,4.473,4.473,0,0,0-5.281,3.956c-.123,1.242-.049,2.5-.092,3.755-.013.4.115.532.518.526C2310.986-866.82,2312.358-866.807,2313.731-866.807Z",
    transform: "translate(-2300.969 877.783)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.959-705.365c.161-.718.639-.983,1.415-.921a1.113,1.113,0,0,1,1.094,1.118,23.594,23.594,0,0,1,.028,2.938,1.181,1.181,0,0,1-1.322,1.22,1.307,1.307,0,0,1-1.323-1.375A21.225,21.225,0,0,1,2412.959-705.365Z",
    transform: "translate(-2401.432 723.73)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.4bf0d1d2.svg";
export { ForwardRef as ReactComponent };